import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';
import { Input } from 'Components/Input';

export default ({
  submissionDate,
  approvalDate,
  formulatorNumber,
  baseFormulaBaseOilNumber,
  engineType,
  isReadAcrossFormula,
  description,
  handleInputChange,
  inputErrors,
}) => {
  return (
    <section className='scene_section'>
      <header>General Info</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Submission Date'
        value={submissionDate && moment(submissionDate).format('MM / DD / YYYY')}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Approval Date'
        value={approvalDate && moment(approvalDate).format('MM / DD / YYYY')}
      />
      <Input
        mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
        inputClassName='input__input-field_primary'
        maxLength={250}
        label='Formulation Number *'
        value={formulatorNumber}
        error={inputErrors.formulatorNumber}
        onChange={handleInputChange('formulatorNumber')}
      />
      {isReadAcrossFormula && (
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Read Across Source'
          value={baseFormulaBaseOilNumber}
        />
      )}
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Engine Oil Type'
        value={engineType}
      />
      <Input
        mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
        inputClassName='input__input-field_primary'
        label='Description'
        maxLength={250}
        value={description}
        error={inputErrors.description}
        onChange={handleInputChange('description')}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Edit/GeneralInformation.jsx